import { FormControl, FormField, FormItem } from "@/src/components/ui/form";
import { FiltersFormT } from "./filters.schema";
import { Combobox } from "../../../components/ui/combobox";
import { Input } from "@/src/components/ui/input";

type Slug = {
  id: string;
};

export const Slug = () => {
  return (
    <div>
      <h3 className="text-lg font-semibold col-span-full mb-4">Xero ID</h3>
      <FormField<FiltersFormT, "slug">
        name="slug"
        render={({ field }) => {
          return (
            <FormItem>
              <FormControl>
                <Input {...field} placeholder="Enter Xero Id..." className="w-96" />
              </FormControl>
            </FormItem>
          );
        }}
      />
    </div>
  );
};
